import { Mail } from 'lucide-react';

export function EmailPage() {
  return (
    <div className="p-8 max-w-5xl mx-auto">
      <header className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">Email</h1>
        <p className="text-sm text-gray-500 mt-1">
          Outbound email setup, templates, and signing domains.
        </p>
      </header>

      <div
        className="rounded-2xl p-10 text-center"
        style={{
          background: 'var(--surface-primary)',
          border: '1px dashed var(--border-default)',
        }}
      >
        <div
          className="inline-flex items-center justify-center w-12 h-12 rounded-xl mb-3"
          style={{ background: 'var(--canvas-base)', color: 'var(--text-tertiary)' }}
        >
          <Mail size={20} strokeWidth={1.5} />
        </div>
        <h3 className="text-sm font-semibold mb-1" style={{ color: 'var(--text-primary)' }}>
          Not connected
        </h3>
        <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
          No email account is linked yet.
        </p>
      </div>
    </div>
  );
}
